import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2caa9e52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row header smalltext" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, "Skill", -1))
const _hoisted_4 = { class: "col-8" }
const _hoisted_5 = { class: "col-4" }
const _hoisted_6 = { class: "col-8" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Zur Zeit sind keine Einschätzungen mehr offen.", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "row mt-5" }
const _hoisted_11 = { class: "col-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (Object.keys(_ctx.feedbacks).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('management.grades.state')), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feedbacks, (value, userid) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "row feedbackentry",
              key: userid
            }, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(value.user.firstname) + " " + _toDisplayString(value.user.lastname), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(value.count > 1 ? `Noch ${value.count} Einschätzungen offen.` : `Noch ${value.count} Einschätzung offen.`), 1)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9)),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = () => _ctx.router.push({ name: 'AdminFeedbackDetails' })),
          class: "detail-button"
        }, [
          _createVNode(_component_Icon, {
            width: 35,
            height: 35,
            path: _ctx.mdiDelete,
            class: "delete hover"
          }, null, 8, ["path"]),
          _createTextVNode(" Einzelne Einschätzungen zurücksetzen oder löschen ")
        ])
      ])
    ])
  ], 64))
}